import { HTMLAttributes } from 'react'
import Link from 'next/link'
import * as CookieConsent from 'vanilla-cookieconsent'

import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type LegalsProps = HTMLAttributes<HTMLDivElement>

const Legals = ({ className, ...props }: LegalsProps) => {
  const { menu } = useStore()

  return (
    <div className={cn('flex space-x-spacing-xs', className)} {...props}>
      {menu?.legals_menu?.menu.map((item, index) => (
        <Link
          key={`legals_menu_${item.id}_${index}`}
          href={item.url}
          scroll={false}
          target={item.target}
          className="group inline-flex"
          onClick={(event) => {
            if (item.url === '#cookies-preferences') {
              event.preventDefault()
              CookieConsent.showPreferences()
            }
          }}
        >
          <Typography variant="small" mask>
            {item.title}
          </Typography>
        </Link>
      ))}
    </div>
  )
}

export default Legals
